import Header from "../../components/feature/Header";
import Footer from "../../components/feature/Footer";
import HeroSection from "./components/HeroSection";
import TrustBar from "./components/TrustBar";
import ServicesSection from "./components/ServicesSection";
import WhyChooseUs from "./components/WhyChooseUs";
import CTABanner from "./components/CTABanner";
import Testimonials from "./components/Testimonials";
import ServiceAreasSection from "./components/ServiceAreasSection";
import ProcessSection from "./components/ProcessSection";
import GallerySection from "./components/GallerySection";
import FAQSection from "./components/FAQSection";
import LeadForm from "./components/LeadForm";

export default function Home() {
  return (
    <>
      <Header />
      <main>
        {/* 1. Hero — first impression */}
        <HeroSection />
        {/* 2. Trust bar — immediate credibility */}
        <TrustBar />
        {/* 3. Services — what we do */}
        <ServicesSection />
        {/* 4. Why Us — credibility deep-dive */}
        <WhyChooseUs />
        {/* 5. Mid-page CTA — conversion checkpoint */}
        <CTABanner />
        {/* 6. Testimonials — social proof */}
        <Testimonials />
        {/* 7. Process — reduce friction */}
        <ProcessSection />
        {/* 8. Gallery — visual proof */}
        <GallerySection />
        {/* 9. Service Areas — local SEO */}
        <ServiceAreasSection />
        {/* 10. FAQ — AI & voice search */}
        <FAQSection />
        {/* 11. Lead form — conversion */}
        <LeadForm />
      </main>
      <Footer />
    </>
  );
}
